import "core-js/stable";
import Vue from "vue";
import App from "./App";
import router from "./router";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store";
import "vue-search-select/dist/VueSearchSelect.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import FullCalendar from "vue-full-calendar";
//import 'fullcalendar/dist/fullcalendar.css'
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import * as VueGoogleMaps from "vue2-google-maps";

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.component("v-select", vSelect);
Vue.prototype.$log = console.log.bind(console);
Vue.use(FullCalendar);
Vue.config.productionTip = false;
Vue.use(VueSweetalert2);
//Vue.use(saveAs);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBTbMcgGot8-R7Rmn7ks6u7PuAeHa-qdB8",
    libraries: "places",
  },
  installComponents: true
});
// var apiURL = "https://api.luthraindia.com/api/";
var apiURL = 'https://api.luthraindia.com/api/';
var feedbackApiURL = "https://api.luthraindia.com/";
window.apiURL = apiURL;
window.feedbackApiURL = feedbackApiURL;

new Vue({
  el: "#app",
  router,
  store,
  icons,
  template: "<App/>",
  components: {
    App,
  },
});
